import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyboardNumbers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Component_95_3",
	"data-name": "Component 95 \\u2013 3",
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_31",
			"data-name": "Ellipse 31",
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#0a0082"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_32",
			"data-name": "Ellipse 32",
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			transform: "translate(19)",
			fill: "#0a0082"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_33",
			"data-name": "Ellipse 33",
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			transform: "translate(0 19)",
			fill: "#0a0082"
		}),
		/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_34",
			"data-name": "Ellipse 34",
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			transform: "translate(19 19)",
			fill: "#0a0082"
		}),
		/* @__PURE__ */ _jsx("text", {
			id: "_1",
			"data-name": 1,
			transform: "translate(0 3)",
			fill: "#fff",
			fontSize: 8,
			fontFamily: "SegoeUI, Segoe UI",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 6.344,
				y: 9,
				children: "1"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			id: "_3",
			"data-name": 3,
			transform: "translate(0 22)",
			fill: "#fff",
			fontSize: 8,
			fontFamily: "SegoeUI, Segoe UI",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 6.344,
				y: 9,
				children: "3"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			id: "_4",
			"data-name": 4,
			transform: "translate(19 3)",
			fill: "#fff",
			fontSize: 8,
			fontFamily: "SegoeUI, Segoe UI",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 6.344,
				y: 9,
				children: "4"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			id: "_9",
			"data-name": 9,
			transform: "translate(19 22)",
			fill: "#fff",
			fontSize: 8,
			fontFamily: "SegoeUI, Segoe UI",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 6.344,
				y: 9,
				children: "9"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgKeyboardNumbers);
export { ForwardRef as ReactComponent };
